<template>
  <div v-if="!isLoading && hasCount">
    <SearchResultListTitle
      :total-count="totalCount"
      :category="`${category}${mtype}`"
      :filter="filter"
    />

    <SearchKeywordResultList
      :cell-list="cellList"
      :thumbnail-info="thumbnailInfo"
      :search-word="searchWord"
      @load-more-fn="loadMore"
    />
  </div>
</template>

<script>
import _ from 'lodash'
import { getSearchList } from '@/common/utils/request'
import { getThumbnailInfo } from '@/common/utils/common'
import SearchResultListTitle from '@/components/search/view/SearchResultListTitle'
import SearchKeywordResultList from '@/components/search/view/SearchKeywordResultList'

export default {
  name: 'SearchKeywordList',
  components: {
    SearchResultListTitle,
    SearchKeywordResultList
  },
  props: {
    searchWord: {
      type: String,
      default: ''
    },
    category: {
      type: String,
      default: ''
    },
    mtype: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      thumbnailInfo: {},
      cellType: '',
      isLoading: true,
      isDataLoading: true,
      totalCount: 0,
      limit: 20,
      cellList: [],
      endOfList: false,
      offset: 0,
      urlList: [], // todo: erase ?
      filter: {},
      query: {},
      transactionkey: (this.$route?.query?.transactionkey || ''),
      orderby: (this.$route?.query?.orderby || 'score')
    }
  },
  computed: {
    hasCount () {
      return this.cellList.length > 0
    }
  },
  created () {
    this.fetchData()
  },
  methods: {
    addMovieMediaType () {
      this.mtype = this.$route?.query?.mtype || ''
      return { mtype: this.mtype }
    },
    setListData (data) {
      const appendCellList = _.get(data, 'cell_toplist.celllist', [])
      const totalCount = _.get(data, 'cell_toplist.totalcount', '0')
      const cellType = _.get(data, 'cell_toplist.cell_type', this.cellType)

      this.cellType = cellType
      this.filter = _.get(data, 'filter', {})
      this.totalCount = Math.max(Number(totalCount), this.totalCount)
      this.cellList = [...this.cellList, ...appendCellList]
      this.thumbnailInfo = getThumbnailInfo(cellType)
      this.urlList = this.cellList.map((cell) => _.get(cell, 'event_list.1.url'))
      this.endOfList = _.get(data, ['cell_toplist', 'celllist'], []).length === 0
    },
    drawParameters () {
      const isPageTypeMovie = (this.category === 'movie')
      const defaultParams = {
        limit: this.limit,
        offset: this.offset,
        keyword: this.searchWord,
        type: this.category,
        orderby: this.orderby,
        transactionkey: this.transactionkey,
        version: 2
      }
      if (isPageTypeMovie) Object.assign(defaultParams, this.addMovieMediaType())

      return defaultParams
    },
    async fetchData () {
      this.isDataLoading = true
      try {
        const params = this.drawParameters()
        const { data } = await getSearchList(_.assign(params, this.query))
        this.setListData(data)
      } catch (error) {
        console.error(error)
      } finally {
        this.isDataLoading = false
        this.isLoading = false
      }
    },
    loadMore () {
      if (this.endOfList) return
      this.offset += this.limit
      this.fetchData()
    },
    updateQuery (newRouteQuery) {
      this.query = newRouteQuery
    },
    resetData () {
      this.cellList = []
      this.offset = 0
      this.totalCount = 0
      this.filter = {}
      this.transactionkey = (this.$route?.query?.transactionkey || '')
      this.orderby = this.$route?.query?.orderby || 'score'
    }
  },
  watch: {
    $route (newRoute) {
      const newRouteQuery = _.get(newRoute, 'query', {})
      this.updateQuery(newRouteQuery)
      this.resetData()
      this.fetchData()
    }
  }
}
</script>
